import { render } from "./BaseForm.vue?vue&type=template&id=330e75e0"
import script from "./BaseForm.vue?vue&type=script&lang=js"
export * from "./BaseForm.vue?vue&type=script&lang=js"
script.render = render

export default script